import React, { useEffect, useState } from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function StickyCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 900);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  return <div className={`fixed inset-x-0 bottom-0 z-50 border-t border-gold/30 bg-ink px-4 py-3 transition-transform duration-300 ease-out sm:hidden ${visible ? 'translate-y-0' : 'translate-y-full'}`} aria-hidden={!visible} data-id="element-299" data-mp="3pd0qe0hgrc4o">
      <a href="#pricing" tabIndex={visible ? 0 : -1} className="flex items-center justify-center gap-2 rounded-full bg-action px-6 py-3.5 text-xs font-bold uppercase tracking-[0.14em] text-ink transition-colors duration-200 hover:bg-action-dark focus:outline-none focus-visible:ring-4 focus-visible:ring-action/40" data-id="element-300" data-mp="3gj4dzde3pe2g">
        Get Direct the Day
        <ArrowRightIcon className="h-4 w-4" aria-hidden="true" data-id="element-301" data-mp="76f9msrynbn9" />
      </a>
    </div>;
}